import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=2a65fbde&"
import script from "./UsersCard.vue?vue&type=script&lang=js&"
export * from "./UsersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports